export const optionPlan_3 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '80万',
					value: 80,
				},
				{
					label: '100万',
					value: 100,
				},
				{
					label: '120万',
					value: 120,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'change',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '误工费用',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '法律费用',
			prop: 'insuredItem3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_3 = new Map([
	[
		80,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/天，上限365天',
			insuredItem3: '10万',
		},
	],
	[
		100,
		{
			insuredItem1: '15万',
			insuredItem2: '100元/天，上限365天',
			insuredItem3: '10万',
		},
	],
	[
		120,
		{
			insuredItem1: '15万',
			insuredItem2: '100元/天，上限365天',
			insuredItem3: '10万',
		},
	],
])

export const optionPlan_6 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '档次',
			prop: 'addMaim',
			type: 'select',
			display: false,
			dicData: [
				{
					label: '普通版',
					value: '0',
				},
				{
					label: '尊贵版',
					value: '1',
				},
			],
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 档次',
					trigger: 'blur',
				},
			],
		},
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '30万',
					value: 30,
				},
				{
					label: '50万',
					value: 50,
				},
				{
					label: '80万',
					value: 80,
				},
				{
					label: '100万',
					value: 100,
				},
				{
					label: '120万',
					value: 120,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '误工费用',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '法律费用',
			prop: 'insuredItem3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_6 = new Map([
	[
		30,
		{
			insuredItem1: '3万',
			insuredItem2: '100元/人/天 上限180天',
			insuredItem3: '10万',
		},
	],
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '100元/人/天 上限180天',
			insuredItem3: '10万',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/人/天 上限180天',
			insuredItem3: '10万',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/人/天 上限180天',
			insuredItem3: '10万',
		},
	],
	[
		120,
		{
			insuredItem1: '20万',
			insuredItem2: '100元/人/天 上限180天',
			insuredItem3: '10万',
		},
	],
])

export const optionPlan_7 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: 110,
	column: [
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '100万',
					value: 100,
				},
				{
					label: '120万',
					value: 120,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '24小时意外',
			prop: 'allDuty',
			span: 24,
			value: '1',
			type: 'select',
			disabled: true,
			dicData: [
				{
					label: '投保',
					value: '1',
				},
				{
					label: '不投保',
					value: '0',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '误工费用',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '法律费用',
			prop: 'insuredItem3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '三者责任',
			prop: 'insuredItem4',
			span: 24,
			type: 'textarea',
			placeholder: ' ',
			disabled: true,
			display: false,
		},
	],
}

export const mapPlan_7 = new Map([
	[
		100,
		{
			insuredItem1: '20万',
			insuredItem2: '100元/天，上限180天',
			insuredItem3: '10万',
		},
	],
	[
		120,
		{
			insuredItem1: '20万',
			insuredItem2: '100元/天，上限180天',
			insuredItem3: '10万',
		},
	],
])

//  国寿财团意
export const optionPlan_8 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '价格档次',
			prop: 'feeRate',
			type: 'select',
			dicData: [
				{
					label: '3档',
					value: 1.15,
				},
				// {
				//     label: '2档（1.10）',
				//     value: 1.10
				// },
				{
					label: '1档',
					value: 1.0,
				},
			],
			span: 24,
			placeholder: '请选择 价格方案',
			rules: [
				{
					required: true,
					message: '请选择 价格方案',
					trigger: 'blur',
				},
			],
		},
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '10万',
					value: 10,
				},
				{
					label: '20万',
					value: 20,
				},
				{
					label: '30万',
					value: 30,
				},
				{
					label: '40万',
					value: 40,
				},
				{
					label: '50万',
					value: 50,
				},
				{
					label: '60万',
					value: 60,
				},
				{
					label: '70万',
					value: 70,
				},
				{
					label: '80万',
					value: 80,
				},
				{
					label: '90万',
					value: 90,
				},
				{
					label: '100万',
					value: 100,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '住院津贴',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_8 = new Map([
	[
		10,
		{
			insuredItem1: '1万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		20,
		{
			insuredItem1: '2万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		30,
		{
			insuredItem1: '3万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		40,
		{
			insuredItem1: '6万',
			insuredItem2: '150元/天 上限180天',
		},
	],
	[
		50,
		{
			insuredItem1: '7万',
			insuredItem2: '150元/天 上限180天',
		},
	],
	[
		60,
		{
			insuredItem1: '9万',
			insuredItem2: '150元/天 上限180天',
		},
	],
	[
		70,
		{
			insuredItem1: '10万',
			insuredItem2: '150元/天 上限180天',
		},
	],
	[
		80,
		{
			insuredItem1: '16万',
			insuredItem2: '200元/天 上限180天',
		},
	],
	[
		90,
		{
			insuredItem1: '18万',
			insuredItem2: '200元/天 上限180天',
		},
	],
	[
		100,
		{
			insuredItem1: '20万',
			insuredItem2: '200元/天 上限180天',
		},
	],
])

//  亚太团意
export const optionPlan_9 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '被保险人职业大类 ',
			prop: 'professionLevel',
			type: 'select',
			dicData: [
				{
					label: '1-2类',
					value: 2,
				},
				{
					label: '3类',
					value: 3,
				},
				{
					label: '4类',
					value: 4,
				},
			],
			span: 24,
			placeholder: '请选择 职业类别',
			rules: [
				{
					required: true,
					message: '请选择 职业类别',
					trigger: 'blur',
				},
			],
		},
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '10万',
					value: 10,
				},
				{
					label: '20万',
					value: 20,
				},
				{
					label: '30万',
					value: 30,
				},
				{
					label: '40万',
					value: 40,
				},
				{
					label: '50万',
					value: 50,
				},
				{
					label: '60万',
					value: 60,
				},
				{
					label: '70万',
					value: 70,
				},
				{
					label: '80万',
					value: 80,
				},
				{
					label: '90万',
					value: 90,
				},
				{
					label: '100万',
					value: 100,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '住院津贴',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_9 = new Map([
	[
		10,
		{
			insuredItem1: '1万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		20,
		{
			insuredItem1: '2万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		30,
		{
			insuredItem1: '3万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		40,
		{
			insuredItem1: '4万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		60,
		{
			insuredItem1: '6万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		70,
		{
			insuredItem1: '7万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		90,
		{
			insuredItem1: '9万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
])

export const mapPlan_9_High = new Map([
	[
		10,
		{
			insuredItem1: '2万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		20,
		{
			insuredItem1: '4万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		30,
		{
			insuredItem1: '6万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		40,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		50,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		60,
		{
			insuredItem1: '12万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		70,
		{
			insuredItem1: '14万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		80,
		{
			insuredItem1: '16万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		90,
		{
			insuredItem1: '18万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		100,
		{
			insuredItem1: '20万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
])

export const mapPlan_9_Low = new Map([
	[
		10,
		{
			insuredItem1: '1万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		20,
		{
			insuredItem1: '2万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		30,
		{
			insuredItem1: '3万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		40,
		{
			insuredItem1: '4万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		60,
		{
			insuredItem1: '6万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		70,
		{
			insuredItem1: '7万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		90,
		{
			insuredItem1: '9万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
])

export const optionPlan_11 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '10万',
					value: 10,
				},
				{
					label: '20万',
					value: 20,
				},
				{
					label: '30万',
					value: 30,
				},
				{
					label: '40万',
					value: 40,
				},
				{
					label: '50万',
					value: 50,
				},
				{
					label: '60万',
					value: 60,
				},
				{
					label: '70万',
					value: 70,
				},
				{
					label: '80万',
					value: 80,
				},
				{
					label: '90万',
					value: 90,
				},
				{
					label: '100万',
					value: 100,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '住院津贴',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '猝死',
			prop: 'insureSuddenDeath',
			type: 'select',
			dicData: [
				{
					label: '投保',
					value: 1,
				},
				{
					label: '不投保',
					value: 0,
				},
			],
			span: 24,
			placeholder: '请选择 是否投保',
			rules: [
				{
					required: true,
					message: '请选择 是否投保',
					trigger: 'blur',
				},
			],
		},
	],
}

export const mapPlan_11 = new Map([
	[
		10,
		{
			insuredItem1: '1万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		20,
		{
			insuredItem1: '2万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		30,
		{
			insuredItem1: '3万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		40,
		{
			insuredItem1: '4万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		60,
		{
			insuredItem1: '6万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		70,
		{
			insuredItem1: '7万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		90,
		{
			insuredItem1: '9万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
])

//安责险
export const optionPlan_12 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: 280,
	column: [
		{
			label: '方案',
			prop: 'addMaim',
			type: 'select',
			dicData: [
				{
					label: '标准版',
					value: 0,
				},
				{
					label: '工标版',
					value: 1,
				},
			],
			span: 24,
			placeholder: '请选择 方案',
			rules: [
				{
					required: true,
					message: '请选择 方案',
					trigger: 'blur',
				},
			],
		},
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '50万',
					value: 50,
				},
				{
					label: '80万',
					value: 80,
				},
				{
					label: '100万',
					value: 100,
				},
				{
					label: '120万',
					value: 120,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '每次事故每人医疗费用责任限额',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '每次事故及累计法律费用责任限额',
			prop: 'test1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '每次事故及累计事故救援费用责任限额',
			prop: 'test2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '累计事故第三者人员伤亡责任限额',
			prop: 'test3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '每次事故第三者人员伤亡责任限额',
			prop: 'test4',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '住院误工费',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

//安责险
export const mapPlan_12 = new Map([
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '100元/天，每次90天,上限180天',
			test1: '10万',
			test2: '10万',
			test3: '30万',
			test4: '10万',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/天，每次90天,上限180天',
			test1: '10万',
			test2: '10万',
			test3: '30万',
			test4: '10万',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/天，每次90天,上限180天',
			test1: '10万',
			test2: '10万',
			test3: '30万',
			test4: '10万',
		},
	],
	[
		120,
		{
			insuredItem1: '15万',
			insuredItem2: '100元/天，每次90天,上限180天',
			test1: '10万',
			test2: '10万',
			test3: '30万',
			test4: '10万',
		},
	],
])

//  美亚
export const optionPlan_13 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '扩展自费药方案',
			prop: 'costDuty',
			type: 'select',
			labelWidth: 300,
			display: false,
			span: 24,
			dicData: [
				{
					label: '否',
					value: '0',
				},
				{
					label: '是',
					value: '1',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择 扩展自费药方案',
					trigger: 'blur',
				},
			],
		},
		{
			label: '意外身故及伤残保障',
			labelWidth: 300,
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '10万',
					value: 10,
				},
				{
					label: '20万',
					value: 20,
				},
				{
					label: '30万',
					value: 30,
				},
				{
					label: '40万',
					value: 40,
				},
				{
					label: '50万',
					value: 50,
				},
				{
					label: '60万',
					value: 60,
				},
				{
					label: '70万',
					value: 70,
				},
				{
					label: '80万',
					value: 80,
				},
				{
					label: '90万',
					value: 90,
				},
				{
					label: '100万',
					value: 100,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '',
			labelWidth: 300,
			prop: 'insuredItem1',
			labelslot: true,
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '',
			labelWidth: 300,
			labelslot: true,
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_13 = new Map([
	[
		10,
		{
			insuredItem1: '1万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		20,
		{
			insuredItem1: '2万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		30,
		{
			insuredItem1: '3万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		40,
		{
			insuredItem1: '4万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		60,
		{
			insuredItem1: '6万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		70,
		{
			insuredItem1: '7万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		90,
		{
			insuredItem1: '9万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/人/天 上限180天',
		},
	],
])

//   前海
export const optionPlan_15 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: 150,
	column: [
		{
			label: '档次',
			prop: 'feeRate',
			type: 'select',
			dicData: [
				{
					label: '1档',
					value: 1,
				},
				{
					label: '2档',
					value: 2,
				},
			],
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 档次',
					trigger: 'blur',
				},
			],
		},
		{
			label: '扩展伤残十级10%',
			prop: 'addMaim',
			type: 'select',
			dicData: [
				{
					label: '是',
					value: '1',
				},
				{
					label: '否',
					value: '0',
				},
			],
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 是否扩展',
					trigger: 'blur',
				},
			],
		},

		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '30万',
					value: 30,
				},
				{
					label: '40万',
					value: 40,
				},
				{
					label: '50万',
					value: 50,
				},
				{
					label: '60万',
					value: 60,
				},
				{
					label: '70万',
					value: 70,
				},
				{
					label: '80万',
					value: 80,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			labelslot: true,
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '误工费用',
			labelslot: true,
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		// ,{
		//     label: '法律费用累计赔偿限额',
		//     labelslot: true,
		//     prop: 'insuredItem3',
		//     span: 24,
		//     placeholder: ' ',
		//     disabled: true
		// },{
		//     label: '法律费用每次事故赔偿限额',
		//     labelslot: true,
		//     prop: 'insuredItem4',
		//     span: 24,
		//     placeholder: ' ',
		//     disabled: true
		// }
	],
}

export const mapPlan_15 = new Map([
	[
		30,
		{
			insuredItem1: '3万',
			insuredItem2: '100元/天',
			insuredItem3: '10万',
			insuredItem4: '10万',
		},
	],
	[
		40,
		{
			insuredItem1: '4万',
			insuredItem2: '100元/天',
			insuredItem3: '10万',
			insuredItem4: '10万',
		},
	],
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '100元/天',
			insuredItem3: '10万',
			insuredItem4: '10万',
		},
	],
	[
		60,
		{
			insuredItem1: '6万',
			insuredItem2: '100元/天',
			insuredItem3: '10万',
			insuredItem4: '10万',
		},
	],
	[
		70,
		{
			insuredItem1: '7万',
			insuredItem2: '100元/天',
			insuredItem3: '10万',
			insuredItem4: '10万',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/天',
			insuredItem3: '10万',
			insuredItem4: '10万',
		},
	],
	[
		90,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/天',
			insuredItem3: '10万',
			insuredItem4: '10万',
		},
	],
	[
		100,
		{
			insuredItem1: '20万',
			insuredItem2: '100元/天',
			insuredItem3: '10万',
			insuredItem4: '10万',
		},
	],
])

//   阳光驾意险
export const optionPlan_14 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '投保金额',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '10万',
					value: 10,
				},
				{
					label: '30万',
					value: 30,
				},
				{
					label: '50万',
					value: 50,
				},
				{
					label: '100万',
					value: 100,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '扩展伤残',
			prop: 'addMaim',
			type: 'select',
			display: false,
			dicData: [
				{
					label: '是',
					value: '1',
				},
				{
					label: '否',
					value: '0',
				},
			],
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 是否扩展',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗保额',
			prop: 'insuredItem1',
			labelslot: true,
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '住院津贴',
			labelslot: true,
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '医疗免赔',
			labelslot: true,
			prop: 'insuredItem3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_14 = new Map([
	[
		10,
		{
			insuredItem1: '1万/座',
			insuredItem2: '100元/天/座',
			insuredItem3: '100元免赔，100%给付',
		},
	],
	[
		30,
		{
			insuredItem1: '3万/座',
			insuredItem2: '100元/天/座',
			insuredItem3: '100元免赔，100%给付',
		},
	],
	[
		50,
		{
			insuredItem1: '5万/座',
			insuredItem2: '100元/天/座',
			insuredItem3: '100元免赔，100%给付',
		},
	],
	[
		100,
		{
			insuredItem1: '10万/座',
			insuredItem2: '100元/天/座',
			insuredItem3: '100元免赔，100%给付',
		},
	],
])

export const optionPlan_16 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '30万',
					value: 30,
				},
				{
					label: '50万',
					value: 50,
				},
				{
					label: '80万',
					value: 80,
				},
				{
					label: '100万',
					value: 100,
				},
				{
					label: '120万',
					value: 120,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '误工费用',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '法律费用',
			prop: 'insuredItem3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_16 = new Map([
	[
		30,
		{
			insuredItem1: '3万',
			insuredItem2: '100元/天/人，每次90天，累计180天为限',
			insuredItem3: '10万',
		},
	],
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '100元/天/人，每次90天，累计180天为限',
			insuredItem3: '10万',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/天/人，每次90天，累计180天为限',
			insuredItem3: '10万',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/天/人，每次90天，累计180天为限',
			insuredItem3: '10万',
		},
	],
	[
		120,
		{
			insuredItem1: '20万',
			insuredItem2: '100元/天/人，每次90天，累计180天为限',
			insuredItem3: '10万',
		},
	],
])

export const optionPlan_17 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: 110,
	column: [
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '100万',
					value: 100,
				},
				{
					label: '120万',
					value: 120,
				},
				{
					label: '130万',
					value: 130,
				},
				{
					label: '150万',
					value: 150,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '三者责任险',
			prop: 'thirdDuty',
			span: 24,
			type: 'select',
			dicData: [
				{
					label: '投保',
					value: '1',
				},
				{
					label: '不投保',
					value: '0',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择 三者责任险',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '误工费用',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '法律费用',
			prop: 'insuredItem3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '三者责任',
			prop: 'insuredItem4',
			span: 24,
			type: 'textarea',
			placeholder: ' ',
			disabled: true,
			display: false,
		},
	],
}

export const mapPlan_17 = new Map([
	[
		100,
		{
			insuredItem1: '30万(医保范围，含合理必须的自费药，100%赔付)',
			insuredItem2: '100元/天（含住院期间以及出院后的休息误工时间，180天为限）',
			insuredItem3: '10万',
			insuredItem4: `含安装维修现场发生并发现的第三者财产损失及人员伤亡赔偿责任，工单机器损失及特定财产不属于第三者保障范围。
年度累计赔偿限额100万元，每次事故赔偿限额60万元，其中每次人身伤亡赔偿限额50万元，每次财产损失赔偿限额10万元。
每次事故财产损失免赔1000元或损失金额的10%，以高者为准。人身伤亡无免赔。`,
		},
	],
	[
		120,
		{
			insuredItem1: '30万(医保范围，含合理必须的自费药，100%赔付)',
			insuredItem2: '100元/天（含住院期间以及出院后的休息误工时间，180天为限）',
			insuredItem3: '10万',
			insuredItem4: `含现场责任及90天新机完工责任，工单机器损失及特定财产不属于第三者保障范围。
年度累计赔偿限额100万元，每次事故赔偿限额60万元，其中每次人身伤亡赔偿限额50万元，每次财产损失赔偿限额10万元。
每次事故财产损失免赔500元，人身伤亡无免赔。`,
		},
	],
	[
		130,
		{
			insuredItem1: '30万(医保范围，含合理必须的自费药，100%赔付)',
			insuredItem2: '100元/天（含住院期间以及出院后的休息误工时间，180天为限）',
			insuredItem3: '10万',
			insuredItem4: `含现场责任及90天新机完工责任，工单机器损失及特定财产不属于第三者保障范围。
年度累计赔偿限额100万元，每次事故赔偿限额60万元，其中每次人身伤亡赔偿限额50万元，每次财产损失赔偿限额10万元。
每次事故财产损失免赔500元，人身伤亡无免赔。`,
		},
	],
	[
		150,
		{
			insuredItem1: '30万(医保范围，含合理必须的自费药，100%赔付)',
			insuredItem2: '100元/天（含住院期间以及出院后的休息误工时间，180天为限）',
			insuredItem3: '10万',
			insuredItem4: `含现场责任及90天新机完工责任，工单机器损失及特定财产不属于第三者保障范围。
年度累计赔偿限额100万元，每次事故赔偿限额60万元，其中每次人身伤亡赔偿限额50万元，每次财产损失赔偿限额10万元。
每次事故财产损失免赔500元，人身伤亡无免赔。`,
		},
	],
])

export const optionPlan_18 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: 280,
	column: [
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '50万',
					value: 50,
				},
				{
					label: '80万',
					value: 80,
				},
				{
					label: '100万',
					value: 100,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗限额（每人每次事故免赔100元）',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '误工费/天（每人每次事故免赔5天）',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '法律费用累计责任限额',
			prop: 'insuredItem3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '三者责任限额（每次事故免赔500元）',
			prop: 'insuredItem4',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '附加24小时意外（每次事故免赔500元）',
			prop: 'insuredItem5',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_18 = new Map([
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '100元/天',
			insuredItem3: '20万',
			insuredItem4: '5万',
			insuredItem5: '5万',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/天',
			insuredItem3: '20万',
			insuredItem4: '5万',
			insuredItem5: '5万',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/天',
			insuredItem3: '20万',
			insuredItem4: '5万',
			insuredItem5: '5万',
		},
	],
])

export const mapPlan_10 = new Map([
	[
		30,
		{
			insuredItem1: '3万',
			insuredItem2: '100元/人/天 上限180天',
			insuredItem3: '10万',
		},
	],
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '100元/人/天 上限180天',
			insuredItem3: '10万',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/人/天 上限180天',
			insuredItem3: '10万',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/人/天 上限180天',
			insuredItem3: '10万',
		},
	],
	[
		120,
		{
			insuredItem1: '12万',
			insuredItem2: '100元/人/天 上限180天',
			insuredItem3: '10万',
		},
	],
])

export const optionPlan_21 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: 110,
	column: [
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '50万',
					value: 50,
				},
				{
					label: '80万',
					value: 80,
				},
				{
					label: '100万',
					value: 100,
				},
				{
					label: '120万',
					value: 120,
				},
				{
					label: '150万',
					value: 150,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '误工费用',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '法律费用',
			prop: 'insuredItem3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_21 = new Map([
	[
		50,
		{
			insuredItem1: '5万',
			insuredItem2: '无免赔，100元/天/上限180天,每次90天',
			insuredItem3: '20万',
		},
	],
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '无免赔，100元/天/上限180天,每次90天',
			insuredItem3: '20万',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '无免赔，100元/天/上限180天,每次90天',
			insuredItem3: '20万',
		},
	],
	[
		120,
		{
			insuredItem1: '10万',
			insuredItem2: '无免赔，100元/天/上限180天,每次90天',
			insuredItem3: '20万',
		},
	],
	[
		150,
		{
			insuredItem1: '12万',
			insuredItem2: '无免赔，100元/天/上限180天,每次90天',
			insuredItem3: '20万',
		},
	],
])

//  安责1-5类
export const optionPlan_22 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: 120,
	column: [
		//addMaim:是否扩展伤残 allDuty:是否附加24小时
		{
			label: '扩展伤残',
			prop: 'addMaim',
			type: 'select',
			dicData: [
				{
					label: '是',
					value: '1',
				},
				{
					label: '否',
					value: '0',
				},
			],
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 是否扩展',
					trigger: 'blur',
				},
			],
		},
		{
			label: '24小时意外',
			prop: 'allDuty',
			span: 24,
			type: 'select',
			dicData: [
				{
					label: '投保',
					value: '1',
				},
				{
					label: '不投保',
					value: '0',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择 附加24小时意外',
					trigger: 'blur',
				},
			],
		},
		{
			label: '误工费用',
			prop: 'delayFee',
			type: 'select',
			span: 24,
			dicData: [
				{
					label: '50元/天，单次免赔3天，单次赔付最高90天，累计最高180天',
					value: '50',
				},
				{
					label: '100元/天，单次免赔3天，单次赔付最高90天，累计最高180天',
					value: '100',
				},
				{
					label: '150元/天，单次免赔3天，单次赔付最高90天，累计最高180天',
					value: '150',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择 误工费用',
					trigger: 'blur',
				},
			],
		},

		{
			label: '住院津贴',
			prop: 'medicalFee',
			type: 'select',
			span: 24,
			dicData: [
				{
					label: '50元/天，单次免赔3天，单次赔付最高90天，累计最高180天',
					value: '50',
				},
				{
					label: '100元/天，单次免赔3天，单次赔付最高90天，累计最高180天',
					value: '100',
				},
				{
					label: '150元/天，单次免赔3天，单次赔付最高90天，累计最高180天',
					value: '150',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择 住院津贴',
					trigger: 'blur',
				},
			],
		},

		{
			label: '意外身故及伤残保障',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '10万',
					value: 10,
				},
				{
					label: '20万',
					value: 20,
				},
				{
					label: '30万',
					value: 30,
				},
				{
					label: '40万',
					value: 40,
				},
				{
					label: '50万',
					value: 50,
				},
				{
					label: '60万',
					value: 60,
				},
				{
					label: '70万',
					value: 70,
				},
				{
					label: '80万',
					value: 80,
				},
				{
					label: '90万',
					value: 90,
				},
				{
					label: '100万',
					value: 100,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'blur',
				},
			],
		},
		{
			label: '工伤及职业病身故伤残',
			prop: 'insuredItem1',
			placeholder: '',
			span: 24,
			disabled: true,
		},
		{
			label: '工伤医疗',
			prop: 'insuredItem2',
			placeholder: '',
			span: 24,
			disabled: true,
		},
		{
			label: '法律费用',
			prop: 'insuredItem3',
			placeholder: '',
			span: 24,
			disabled: true,
		},
		// {
		//   label: '误工费用',
		//   prop: 'insuredItem4',
		//   placeholder: '',
		//   span: 24,
		//   disabled: true
		// },
		{
			label: '医疗免赔',
			prop: 'insuredItem4',
			placeholder: '',
			span: 24,
			disabled: true,
		},
	],
}

export const mapPlan_22 = new Map([
	[
		10,
		{
			insuredItem1: '10万/人',
			insuredItem2: '1万/人',
			insuredItem3: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
			insuredItem4: '医疗免赔200元后100%赔付',
		},
	],
	[
		20,
		{
			insuredItem1: '20万/人',
			insuredItem2: '2万/人',
			insuredItem3: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
			insuredItem4: '医疗免赔200元后100%赔付',
		},
	],
	[
		30,
		{
			insuredItem1: '30万/人',
			insuredItem2: '3万/人',
			insuredItem3: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
			insuredItem4: '医疗免赔200元后100%赔付',
		},
	],
	[
		40,
		{
			insuredItem1: '40万/人',
			insuredItem2: '4万/人',
			insuredItem3: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
			insuredItem4: '医疗免赔200元后100%赔付',
		},
	],
	[
		50,
		{
			insuredItem1: '50万/人',
			insuredItem2: '5万/人',
			insuredItem3: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
			insuredItem4: '医疗免赔200元后100%赔付',
		},
	],
	[
		60,
		{
			insuredItem1: '60万/人',
			insuredItem2: '6万/人',
			insuredItem3: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
			insuredItem4: '医疗免赔200元后100%赔付',
		},
	],
	[
		70,
		{
			insuredItem1: '70万/人',
			insuredItem2: '7万/人',
			insuredItem3: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
			insuredItem4: '医疗免赔200元后100%赔付',
		},
	],
	[
		80,
		{
			insuredItem1: '80万/人',
			insuredItem2: '8万/人',
			insuredItem3: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
			insuredItem4: '医疗免赔200元后100%赔付',
		},
	],
	[
		90,
		{
			insuredItem1: '90万/人',
			insuredItem2: '9万/人',
			insuredItem3: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
			insuredItem4: '医疗免赔200元后100%赔付',
		},
	],
	[
		100,
		{
			insuredItem1: '100万/人',
			insuredItem2: '10万/人',
			insuredItem3: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
			insuredItem4: '医疗免赔200元后100%赔付',
		},
	],
])

export const optionPlan_23 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '身故/伤残',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '80万',
					value: 80,
				},
				{
					label: '100万',
					value: 100,
				},
				{
					label: '120万',
					value: 120,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'change',
				},
			],
		},
		{
			label: '24小时意外',
			prop: 'allDuty',
			span: 24,
			type: 'select',
			dicData: [
				{
					label: '投保',
					value: 1,
				},
				{
					label: '不投保',
					value: 0,
				},
			],
			rules: [
				{
					required: true,
					message: '请选择 是否投保24小时意外',
					trigger: 'blur',
				},
			],
		},
		{
			label: '装卸意外',
			prop: 'feeRate',
			span: 24,
			type: 'select',
			placeholder: '请选择 是否扩展货车司机、随车人员参与装卸货物的责任',
			dicData: [
				{
					label: '是',
					value: 1,
				},
				{
					label: '否',
					value: 0,
				},
			],
			rules: [
				{
					required: true,
					message: '是否扩展货车司机、随车人员参与装卸货物的责任？',
					trigger: 'blur',
				},
			],
		},
		{
			label: '医疗费用',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '误工费用',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '法律费用',
			prop: 'insuredItem3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '猝死限额',
			prop: 'insuredItem4',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_23 = new Map([
	[
		80,
		{
			insuredItem1: '8万',
			insuredItem2: '100元/天，以180天为限',
			insuredItem3: '每次/累计赔偿限额10万',
			insuredItem4: '身故/伤残限额的20%',
		},
	],
	[
		100,
		{
			insuredItem1: '10万',
			insuredItem2: '100元/天，以180天为限',
			insuredItem3: '每次/累计赔偿限额10万',
			insuredItem4: '身故/伤残限额的20%',
		},
	],
	[
		120,
		{
			insuredItem1: '20万',
			insuredItem2: '100元/天，以180天为限',
			insuredItem3: '每次/累计赔偿限额10万',
			insuredItem4: '身故/伤残限额的20%',
		},
	],
])

export const optionPlan_29 = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '投保金额',
			prop: 'coverage',
			type: 'select',
			dicData: [
				{
					label: '10万',
					value: 10,
				},
				{
					label: '20万',
					value: 20,
				},
				{
					label: '30万',
					value: 30,
				},
				{
					label: '50万',
					value: 50,
				},
			],
			placeholder: '请选择 保额',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 保额',
					trigger: 'change',
				},
			],
		},
		{
			label: '身故/伤残',
			prop: 'insuredItem1',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '意外医疗费用补偿',
			prop: 'insuredItem2',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
		{
			label: '意外住院津贴',
			prop: 'insuredItem3',
			span: 24,
			placeholder: ' ',
			disabled: true,
		},
	],
}

export const mapPlan_29 = new Map([
	[
		10,
		{
			insuredItem1: '10万',
			insuredItem2: '1万',
			insuredItem3: '100元/天，0免赔天数，每次以30天为限，累计以180天为限',
		},
	],
	[
		20,
		{
			insuredItem1: '20万',
			insuredItem2: '2万',
			insuredItem3: '100元/天，0免赔天数，每次以30天为限，累计以180天为限',
		},
	],
	[
		30,
		{
			insuredItem1: '30万',
			insuredItem2: '3万',
			insuredItem3: '100元/天，0免赔天数，每次以30天为限，累计以180天为限',
		},
	],
	[
		50,
		{
			insuredItem1: '50万',
			insuredItem2: '5万',
			insuredItem3: '100元/天，0免赔天数，每次以30天为限，累计以180天为限',
		},
	],
])
